import {inject, observer} from "mobx-react";
import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import {IValuesStore} from "Stores/Values/types";
import {IManagementStore} from "Stores/Management/types";
import {IAuthStore} from "Stores/Auth/types";
import {Values} from "Tools/Values";
import {observable} from "mobx";
import {Organisation} from "@src/Interfaces/Entity/Organisation";
import {
    OrganisationDialogForm
} from "@src/Components/Pages/Main/Content/Organisations/OrganisationsContent/OrganisationDialog/OrganisationDialogForm/OrganisationDialogForm";

interface IOrganisationDialogProps {
    organisation: Organisation;
    onClose: () => void;
    isOpened: boolean;
    values?: IValuesStore;
    management?: IManagementStore;
    auth?: IAuthStore;
    isEdit: boolean;
}

@inject("auth", "values", "management")
@observer
export class OrganisationDialog extends React.Component<IOrganisationDialogProps> {
    private dataFormRef: any;

    @observable organisation: Organisation = this.props.organisation;
    @observable isConfirmBtnDisabled: boolean = false;

    validateFieldUniqueness() {
        const originalName = this.organisation?.name;
        const organisations = this.props.management.organisations;

        return function (value: string) {
            if (!value || value === originalName) {
                return true;
            }

            const filtered = organisations.find(
                (item) => item.name.toLowerCase() === value.toLowerCase()
            );
            
            return !filtered;
        }
    };

    onFormSubmit = async (values: Organisation) => {
        try {
            await this.props.management.saveOrganisation(values, !this.props.isEdit);
            this.props.onClose();
        } catch (error) {
            console.error(error);
        }
    };

    async onConfirmButtonClick() {
        this.dataFormRef.dispatchEvent(new Event("submit", {cancelable: true, bubbles: true}));
    };

    render() {
        return (
            <Dialog
                maxWidth={"lg"}
                open={this.props.isOpened}
                onClose={this.props.onClose}
            >
                <DialogTitle id="person-dialog-title">
                    {this.props.isEdit ? Values.getLocalizationValue("editOrganisation") : Values.getLocalizationValue("addOrganisation")}
                </DialogTitle>

                <DialogContent style={{minWidth: 500, paddingBottom: 32}}>
                    <OrganisationDialogForm
                        initialValues={this.props.organisation}
                        setRef={ref => this.dataFormRef = ref}
                        uniquenessValidator={this.validateFieldUniqueness.bind(this)}
                        onSubmit={(data) => this.onFormSubmit(data)}
                        isEdit={this.props.isEdit}
                    />
                </DialogContent>

                <DialogActions style={{padding: 16}}>
                    <Button
                        variant={"outlined"}
                        onClick={() => this.props.onClose()}
                        color="default"
                    >
                        {Values.getLocalizationValue("cancel")}
                    </Button>
                    <Button
                        variant={"contained"}
                        onClick={() => this.onConfirmButtonClick()}
                        disabled={this.isConfirmBtnDisabled}
                        color="primary"
                    >
                        {Values.getLocalizationValue("confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}